/* Red Dot Sight UK — Component JavaScript (tiny, dependency-free, deferred). */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
   * FAQ — single-open accordion behaviour
   * ------------------------------------------------------------------ */
  function initFaqSingleOpen() {
    var groups = document.querySelectorAll('.rdsu-faq[data-rdsu-faq-single="true"]');
    groups.forEach(function (group) {
      var items = group.querySelectorAll('details.rdsu-faq__item');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          // While a search filter is running, matches are opened deliberately —
          // don't let single-open mode slam them shut again.
          if (group.dataset.rdsuFaqFiltering === 'true') return;
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item && other.open) other.open = false; });
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
   * FAQ — live keyword search
   *
   * Filters by toggling the `hidden` attribute on items that are already in
   * the DOM. Nothing is ever removed, so crawlers, answer engines and the
   * FAQPage JSON-LD always see the complete question set.
   * ------------------------------------------------------------------ */
  function faqTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var parent = node.parentNode;
        if (!parent) return NodeFilter.FILTER_REJECT;
        var tag = parent.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'MARK') return NodeFilter.FILTER_REJECT;
        if (parent.classList && parent.classList.contains('rdsu-faq__icon')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);
    return nodes;
  }

  // Wraps every occurrence of each term in <mark>, operating on text nodes only
  // so links, <strong> and other answer markup survive untouched.
  function faqHighlight(root, terms) {
    faqTextNodes(root).forEach(function (node) {
      var text = node.nodeValue;
      var lower = text.toLowerCase();
      var ranges = [];
      terms.forEach(function (term) {
        var i = lower.indexOf(term);
        while (i !== -1) {
          ranges.push([i, i + term.length]);
          i = lower.indexOf(term, i + term.length);
        }
      });
      if (!ranges.length) return;
      ranges.sort(function (a, b) { return a[0] - b[0]; });
      var merged = [];
      ranges.forEach(function (r) {
        var last = merged[merged.length - 1];
        if (last && r[0] <= last[1]) { last[1] = Math.max(last[1], r[1]); } else { merged.push([r[0], r[1]]); }
      });
      var frag = document.createDocumentFragment();
      var pos = 0;
      merged.forEach(function (r) {
        if (r[0] > pos) frag.appendChild(document.createTextNode(text.slice(pos, r[0])));
        var mark = document.createElement('mark');
        mark.textContent = text.slice(r[0], r[1]);
        frag.appendChild(mark);
        pos = r[1];
      });
      if (pos < text.length) frag.appendChild(document.createTextNode(text.slice(pos)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function initFaqSearch() {
    var controls = document.querySelectorAll('[data-rdsu-faq-search]');
    controls.forEach(function (control) {
      var list = document.getElementById(control.getAttribute('data-rdsu-faq-search'));
      if (!list) return;

      var input = control.querySelector('.rdsu-faq-search__input');
      var clearBtn = control.querySelector('.rdsu-faq-search__clear');
      var status = control.querySelector('.rdsu-faq-search__status');
      var noun = control.getAttribute('data-rdsu-faq-noun') || 'questions';
      var items = Array.prototype.slice.call(list.querySelectorAll('.rdsu-faq__item'));
      if (!input || !items.length) return;

      var groups = Array.prototype.slice.call(list.querySelectorAll('.rdsu-faq-hub__group'));
      var accordions = Array.prototype.slice.call(list.querySelectorAll('.rdsu-faq[data-rdsu-faq-single="true"]'));
      if (list.classList.contains('rdsu-faq') && list.dataset.rdsuFaqSingle === 'true') accordions.push(list);

      var records = items.map(function (item) {
        var question = item.querySelector('.rdsu-faq__question');
        var answer = item.querySelector('.rdsu-faq__answer');
        return {
          item: item,
          question: question,
          answer: answer,
          questionHtml: question ? question.innerHTML : '',
          answerHtml: answer ? answer.innerHTML : '',
          wasOpen: item.open,
          text: (
            (question ? question.textContent : '') + ' ' + (answer ? answer.textContent : '')
          ).toLowerCase().replace(/\s+/g, ' ')
        };
      });

      function setFiltering(on) {
        accordions.forEach(function (group) { group.dataset.rdsuFaqFiltering = on ? 'true' : 'false'; });
      }

      function run() {
        var raw = input.value.trim();
        var terms = raw.toLowerCase().split(/\s+/).filter(Boolean);
        var filtering = terms.length > 0;
        control.classList.toggle('is-filled', raw.length > 0);

        setFiltering(true);
        var visible = 0;

        records.forEach(function (record) {
          // Always restore the pristine markup before re-marking.
          if (record.question) record.question.innerHTML = record.questionHtml;
          if (record.answer) record.answer.innerHTML = record.answerHtml;

          var match = !filtering || terms.every(function (term) { return record.text.indexOf(term) !== -1; });
          if (record.item.hidden === match) record.item.hidden = !match;

          if (!filtering) {
            record.item.open = record.wasOpen;
            return;
          }
          if (!match) {
            record.item.open = false;
            return;
          }
          visible++;
          record.item.open = true;
          if (record.question) faqHighlight(record.question, terms);
          if (record.answer) faqHighlight(record.answer, terms);
        });

        // Hide whole category groups (FAQ hub) that have nothing left in them.
        groups.forEach(function (group) {
          var any = group.querySelector('.rdsu-faq__item:not([hidden])');
          group.hidden = filtering && !any;
        });

        list.classList.toggle('is-empty', filtering && visible === 0);

        if (status) {
          if (!filtering) {
            status.textContent = '';
          } else if (visible === 0) {
            status.textContent = 'No ' + noun + ' match “' + raw + '”.';
          } else {
            status.textContent = visible + ' of ' + records.length + ' ' + noun + ' match “' + raw + '”.';
          }
        }

        // Restore single-open behaviour once the list is unfiltered again.
        window.setTimeout(function () { setFiltering(filtering); }, 0);
      }

      function clear() {
        input.value = '';
        run();
        input.focus();
      }

      input.addEventListener('input', run);
      input.addEventListener('search', run);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && input.value) {
          event.preventDefault();
          clear();
        }
      });
      if (clearBtn) clearBtn.addEventListener('click', clear);

      // Deep link support: /pages/faq?q=battery lands pre-filtered.
      try {
        var q = new URLSearchParams(window.location.search).get('q');
        if (q) input.value = q;
      } catch (e) {}

      control.hidden = false;
      if (input.value) run();
    });
  }

  /* ---------------------------------------------------------------------
   * Recently viewed products
   * ------------------------------------------------------------------ */
  var RV_KEY = 'rdsu_recently_viewed';
  var RV_MAX = 8;
  function rvRead() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; } }
  function rvWrite(list) { try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {} }
  function rvEscape(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rvCard(p) {
    var img = p.image ? '<img src="' + rvEscape(p.image) + '" alt="' + rvEscape(p.title) + '" loading="lazy" width="300" height="300">' : '<div style="width:100%;height:100%;background:var(--rdsu-surface);"></div>';
    var vendor = p.vendor ? '<span class="rdsu-product-card__vendor">' + rvEscape(p.vendor) + '</span>' : '';
    return '<article class="rdsu-product-card" role="listitem"><a class="rdsu-product-card__media" href="' + rvEscape(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a><div class="rdsu-product-card__body">' + vendor + '<h3 class="rdsu-product-card__title"><a href="' + rvEscape(p.url) + '">' + rvEscape(p.title) + '</a></h3><div class="rdsu-product-card__price"><span>' + rvEscape(p.price) + '</span></div></div></article>';
  }
  function initRecentlyViewed() {
    var section = document.querySelector('.rdsu-recently-viewed');
    if (!section) return;
    var list = section.querySelector('.rdsu-recently-viewed__list');
    var dataEl = section.querySelector('.rdsu-recently-viewed__current');
    var current = null;
    if (dataEl) { try { current = JSON.parse(dataEl.textContent); } catch (e) {} }
    var stored = rvRead();
    var others = current ? stored.filter(function (p) { return p.handle !== current.handle; }) : stored;
    if (others.length && list) { list.innerHTML = others.slice(0, RV_MAX).map(rvCard).join(''); section.hidden = false; }
    if (current && current.handle) { stored = stored.filter(function (p) { return p.handle !== current.handle; }); stored.unshift(current); rvWrite(stored.slice(0, RV_MAX)); }
  }

  function init() { initFaqSingleOpen(); initFaqSearch(); initRecentlyViewed(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
